export const getUserLocation = async (coordinates) => await fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${coordinates.latitude}&longitude=${coordinates.longitude}&localityLanguage=en`)
    .then((response) => response.json())
    .catch((error) => console.log(error));
